import { TJSONObject, isBool, val2Bool } from "@ingenieria_insoft/ispgen";
import { getItem, saveError, setItem } from "./UlStore";

export type TISCache = {
	[hostname: string]: {
		[port: string]: {
			[method: string]: {
				[params: string]: {
					response: any;
					fhcreacion: number;
				};
			};
		};
	};
};
var cache: TISCache = {};

export async function verificarBorrarCache() {
	try {
		var val = await getItem("borrarCache");
		if (val2Bool(val)) {
			cache = {};
			await setItem("borrarCache", "false");
		}
	} catch (error) {
		saveError("verificarBorrarCache", "", error as Error);
	}
}

export function GetObjectCache(url: string, nMethod: string, key: string): TJSONObject {
	try {
		if (!isBool(url) || !isBool(nMethod) || !isBool(key)) return {};
		var ObjUrl = new URL(url);
		var n1 = ObjUrl.hostname;
		var n2 = ObjUrl.port;
		var n3 = nMethod.toLowerCase();
		var n4 = key.toLowerCase();
		if (isBool(cache[n1]) && isBool(cache[n1][n2]) && isBool(cache[n1][n2][n3]) && isBool(cache[n1][n2][n3][n4])) return cache[n1][n2][n3][n4];
		return {};
	} catch (error) {
		saveError("GetObjectCache", nMethod + ":" + key, error as Error);
		return {};
	}
}

export function setObjectCache(url: string, nMethod: string, key: string, json: object | string | number) {
	try {
		let ObjCache = GetObjectCache(url, nMethod, key);
		if (isBool(ObjCache)) return;
		if (!isBool(url) || !isBool(nMethod) || !isBool(key)) return;

		var ObjUrl = new URL(url);
		var n1 = ObjUrl.hostname;
		var n2 = ObjUrl.port;
		var n3 = nMethod.toLowerCase();
		var n4 = key.toLowerCase();

		if (!isBool(cache[n1])) cache[n1] = {};
		if (!isBool(cache[n1][n2])) cache[n1][n2] = {};
		if (!isBool(cache[n1][n2][n3])) cache[n1][n2][n3] = {};

		cache[n1][n2][n3][n4] = {
			fhcreacion: new Date().getTime(),
			response: json,
		};
	} catch (error) {
		saveError("setObjectCache", nMethod + ":" + key, error as Error);
	}
}
